import Haji from '../paket-perjalanan/haji.jsx';
import Umroh from '../paket-perjalanan/umroh';

function PaketPerjalanan() {
  return (
    <div>
      <Haji />
      <Umroh />
    </div>
  );
}

export default PaketPerjalanan;
